<template>
	<sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
		<template slot="toolbar-title">
			<rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
		</template>
		<template slot="table-body">
			<accettazione-consensi-list-component ref="cmpAccettazioneConsensiListComponent"></accettazione-consensi-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import AccettazioneConsensiListComponent from "../../../accettazione/components/AccettazioneConsensiListComponent.vue";
export default {
	props: {
		utente: { type: Object },
	},
	components: {
		SaPageLayout,
		RsaOspiteAnagraficaComponent,
		AccettazioneConsensiListComponent,
	},
	data() {
		return {
			idAccettazione: null,
			btnNuovaRichiestaEsameHidden: true,
			btnNuovaRichiestaUscita: true,
			filtro: {},
			btnNewVisible: true,
			pathResource: null,
			pathResourceAccettazione: "/accettazioni",
			linkedit: null,
			linkback: "/rsagestioneospiti",
			showModalLoading: false,
			listKey: 0,
			jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
		};
	},
	mounted() {
		let me = this;
		me.idAccettazione = this.$route.query.idAccettazione;
		me.loadAccettazione();
	},
	methods: {
		loadAccettazione() {
			let me = this;
			me.showModalLoading = true;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
			axios.get(link)
				.then((response) => {
					me.jsonData = response.data.data;
					me.$refs.cmpAccettazioneConsensiListComponent.setDati(me.idAccettazione, me.jsonData.codiceStruttura, "NURITY");
					me.showModalLoading = false;
				})
				.catch(() => {
					me.showModalLoading = false;
				});
		},
	},
};
</script>

<style></style>
